<script setup lang="ts">
import { Color, ColorSemantic } from '@previo/codebooks'
import { PWhiteSpace, type PMaxLines } from '../types'
import PTextHighlighted from './PTextHighlighted.vue'

type Props = {
  text?: null | string | number
  color?: null | Color | ColorSemantic
  bold?: boolean
  italic?: boolean
  underline?: boolean
  strike?: boolean
  maxLines?: null | PMaxLines
  ellipsis?: boolean
  whiteSpace?: PWhiteSpace
}

const props = withDefaults(defineProps<Props>(), {
  color: ColorSemantic.TEXT_STANDARD,
  bold: false,
  italic: false,
  underline: false,
  strike: false,
  ellipsis: false,
  whiteSpace: PWhiteSpace.PRE_LINE,
})
</script>

<template>
  <p-text-highlighted v-bind="props">
    <slot />
  </p-text-highlighted>
</template>
